import { isClient } from 'shared/components/screen-height-div'
import { formPath } from './form-path'

export const formUrl = (path: string, withBasePath = true) => {
  if (isClient()) {
    return `${window.location.origin}${formPath(path, withBasePath)}`
  }
}
